import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useInventoryList(params, config) {
  return useSWR(
    !!params?.warehouse
      ? {
          path: `/api/v1/inventories`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
      ...config,
    },
  );
}

export default useInventoryList;
